export const isFirstBAInvitedUser = (businessAccounts = []) => {
  const ownerAccounts = businessAccounts.filter((account) => account?.role?.name === "Owner")

  return ownerAccounts.length === 1
}
